// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#password-reset-text {\n  max-width: 500px;\n}\n.spelling {\n  hyphens: auto;\n}\n", "",{"version":3,"sources":["webpack://./src/account/style/PasswordReset.less"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;AAEA;EACE,aAAA;AAAF","sourcesContent":["#password-reset-text {\n  max-width: 500px;\n}\n\n.spelling {\n  hyphens: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
